/* eslint-disable @typescript-eslint/no-explicit-any */
import WebApp from "@twa-dev/sdk";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";

WebApp.ready();
WebApp.disableVerticalSwipes();

localStorage.clear(); // NOTE: 12월 23일에 제거 필요

(window as any).webApp = WebApp;
createRoot(document.getElementById("root")!).render(<App />);
